module.exports = __webpack_public_path__ + "static/media/roiTestimonialMob3x.3a989119.png";